import type { Group } from "building-types/groups/group";
import type { Table } from "common/data/table";
import { builtInPropsEntityGroups } from "./elements/propCatalog/builtInProps";
import { SystemDataSequenceEntityGroups, SystemDataSequenceGroup } from "./systemDataSequences";
import { systemParametersEntityGroups, systemParametersGroupsTable } from "./systemParameters";

/** TODO: remove the system groups from the Doc and add them here */
export const SystemGroups: Table<Group> = {
  ...systemParametersGroupsTable,
  [SystemDataSequenceGroup.id]: SystemDataSequenceGroup,
};

/** TODO: remove the system entity groups from the Doc and add them here */
export const SystemEntityGroups: Table<Group["id"]> = {
  ...systemParametersEntityGroups,
  ...builtInPropsEntityGroups,
  ...SystemDataSequenceEntityGroups,
};
